import Counter from './HookCounter';

export default Counter;